﻿import "./scss/style.scss";
import { RedirectModal } from "../../../Fundraising.UI.Shared/Modules/redirectModal/RedirectModal";

$(function () {
    window.addEventListener('DOMContentLoaded', function () {
        const redirection = new RedirectModal({
            title: "American Publishers is now Funderworks",
            message: "You have been redirected to  Funderworks.com from APMags.com."
        });
    });
});